import dayjs from "dayjs";
import styled from "styled-components";

import { ChangeIndicator } from "./change-indicator";

const StyledText = styled.text`
  font-size: 2.25rem;
  font-weight: bold;
  fill: #1f2937;
`;

export const StyledForeignObjectDiv = styled.div<{ changeRate: number }>`
  width: 82px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15.67px;
  background-color: ${({ changeRate }) =>
    changeRate > 0
      ? "#E3F2FD" // 상승: 하늘색 (Material-UI light blue)
      : changeRate < 0
        ? "#FFEBEE" // 하락: 연한 빨간색 (Material-UI light red)
        : "#F5F5F5"}; // 변화 없음: 연회색
`;

const TooltipContainer = styled.div`
  background: #000000e5;
  padding: 10px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  min-width: 190px;
`;

const TooltipTitle = styled.p`
  font-size: 0.75rem;
  color: #9ca1ab;
  font-weight: 600;
  margin-bottom: 6px;
`;

const TooltipRow = styled.p`
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const TooltipLabel = styled.span`
  color: #fff;
`;

const TooltipValue = styled.span<{ color?: string }>`
  color: ${({ color }) => color || "#fff"};
  font-weight: 500;
`;

const CustomChangeIndicator = styled(ChangeIndicator)`
  font-size: 16px;
`;

export const CenterLabel = ({ totalValue, changeRate }: any) => {
  return (
    <g>
      <StyledText x="50%" y="45%" textAnchor="middle" dominantBaseline="middle">
        {totalValue.toLocaleString()}명
      </StyledText>
      <foreignObject x="0" y="55%" width="100%" height="32">
        <StyledForeignObjectDiv changeRate={changeRate.value}>
          <CustomChangeIndicator showIcon changeRate={changeRate} />
        </StyledForeignObjectDiv>
      </foreignObject>
    </g>
  );
};

export const CustomTooltip = ({ active, payload, totalMembers }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const currentValue = payload[0].value;

    let percentageOfTotal = 0;
    if (totalMembers > 0) {
      percentageOfTotal = (currentValue / totalMembers) * 100;
    }

    return (
      <TooltipContainer>
        <TooltipTitle>{dayjs().format("YYYY.MM.DD")} 실시간 현황</TooltipTitle>

        {/* 항목별 유효 회원 수 */}
        <TooltipRow>
          <TooltipLabel>{data.name} 유효 회원 수</TooltipLabel>
          <TooltipValue>{currentValue.toLocaleString()}명</TooltipValue>
        </TooltipRow>

        {/* --- 전체 대비 비율 --- */}
        <TooltipRow>
          <TooltipLabel>전체 유효 회원 수 대비</TooltipLabel>
          <TooltipValue color="#85AEFF">
            {percentageOfTotal.toFixed(1)}%
          </TooltipValue>
        </TooltipRow>
      </TooltipContainer>
    );
  }
  return null;
};
